import { Link } from "react-router-dom";
import { PRODUCT_MEDIA } from "@/data/content";

export const MomentProducts = ({ slugs, className = "" }) => (
  <div className={`flex items-end gap-3 ${className}`}>
    {slugs.map((slug) => (
      <Link key={slug} to={`/prodotto/${slug}`} aria-label={PRODUCT_MEDIA[slug].name} className="group/arch relative h-full min-w-0 flex-1 overflow-hidden rounded-2xl bg-parchment ring-1 ring-copper/20">
        <img src={PRODUCT_MEDIA[slug].image} alt={PRODUCT_MEDIA[slug].name} loading="lazy" style={{ objectPosition: PRODUCT_MEDIA[slug].focus ?? "50% 50%" }} className="h-full w-full object-cover transition-transform duration-1000 group-hover/arch:scale-105" />
      </Link>
    ))}
  </div>
);

export const MomentLinks = ({ slugs }) => (
  <ul className="flex flex-wrap gap-2">
    {slugs.map((slug) => (
      <li key={slug}>
        <Link to={`/prodotto/${slug}`} data-testid={`ritual-link-${slug}`} className="inline-flex h-11 items-center rounded-full border border-navy/20 px-4 text-[14px] text-navy transition-colors duration-300 hover:bg-navy hover:text-ivory">
          {PRODUCT_MEDIA[slug].name}
        </Link>
      </li>
    ))}
  </ul>
);

export const MomentText = ({ moment, large = false }) => (
  <div>
    <div className="flex items-baseline gap-4">
      <span className={`font-brand text-copper ${large ? "text-6xl" : "text-5xl"}`}>{moment.n}</span>
      <span className="eyebrow">{moment.time}</span>
    </div>
    <h3 className={`mt-5 font-display font-medium leading-[1.05] text-navy ${large ? "text-4xl xl:text-5xl" : "text-4xl"}`}>{moment.title}</h3>
    <p className="mt-5 text-[17px] leading-relaxed text-slate2">{moment.text}</p>
  </div>
);
